import { Updater } from "use-immer"
// my imports:
import * as Util from "@/app/lib/system/util"
import { AnyGameObj } from "@/app/lib/game-state/game-types";
import WordModule from "@/app/lib/game-state/word-module"
import LetterModule from "@/app/lib/game-state/letter-module"
import Nav from "@/app/lib/input/nav"
import InputHandler from "@/app/lib/input/input-handler"
import UI from "@/app/lib/ui/ui"

// if we have no focus, we treat it as if we are trying to input to the first open entry slot in the puzzle
export function handleBlurIngredientClick({
    letter, game, ui
} : {
    letter: string,
    game: AnyGameObj,
    ui: UI
}) {
    if (game.state.freezeInputs()) {
        return;
    }

    const nav = new Nav(0, 0, game.state);
    const earliestEmptySlot = nav.findEarliestEmptySlot();

    if (!earliestEmptySlot)
        return;

    // if there is an earliest empty slot, we call the focused function on that slot
    handleFocusIngredientClick({
        letter,
        wordIndex: earliestEmptySlot.wordIndex,
        letterPosition: earliestEmptySlot.letterPosition,
        game,
        ui
    });
}

export function handleFocusIngredientClick({
    letter, wordIndex, letterPosition, game, ui
} : {
    letter: string,
    wordIndex: number,
    letterPosition: number,
    game: AnyGameObj, 
    ui: UI
}) {
    if (game.state.freezeInputs()) {
        return;
    }

    const wordModule = game.state.words[wordIndex];
    const letterModule = wordModule.letters[letterPosition];

    const input: InputHandler = new InputHandler({
        wordIndex,
        letterPosition,
        game,
        ui
    });

    // are we at a given or solved?
    if (
        wordModule.solved
        || letterModule.type === 'given'
    ) {
        input.goNextEntry();
        return;
    }

    // otherwise, we fill with the letter we clicked
    input.fill(letter);
}

export function handleIngredientBackSpace({
    wordIndex, letterPosition, game, ui
} : {
    wordIndex: number,
    letterPosition: number,
    game: AnyGameObj
    ui: UI
}) {
    if (game.state.freezeInputs()) {
        return;
    }

    const input: InputHandler = new InputHandler({
        wordIndex,
        letterPosition,
        game,
        ui
    });

    input.backspace();
}